

// import React, { useState, useEffect } from "react";
// import {
//   AppBar,
//   Toolbar,
//   Button,
//   Box,
//   ToggleButton,
//   ToggleButtonGroup,
//   Typography,
//   styled,
//   IconButton,
//   Menu,
//   MenuItem,ListItemIcon,ListItemText,Avatar
// } from "@mui/material";
// import { useNavigate, useLocation } from "react-router-dom";
// import MenuIcon from "@mui/icons-material/Menu";
// import ayujalogo from "../Logos/Ayuja_Logo.jpg";
// import axios from "axios";
// import { fetchUserFromRedis } from "../../Components/HomePage/AuthonticationScreens/Register";
// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
// import LocalPharmacyOutlinedIcon from "@mui/icons-material/LocalPharmacyOutlined";
// import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
// import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
// import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
// import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
// import CustomDialog from "../../CustomDialog";



// const StyledAvatar = styled("div")`
//   font-family: "Roboto";
//   letter-spacing: 0.1px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 40px;
//   height: 40px;
//   background-color: #006D77;
//   color: white;
//   font-size: 20px;
//   font-weight: bold;
//   border-radius: 50%;
// `;

// function Header() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [selected, setSelected] = useState("");
//   const [user, setUser] = useState(null);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const logoutapi=process.env.REACT_APP_LOGOUT_API;
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [dialogMessage, setDialogMessage] = useState("");
//   const [onConfirmLogout, setOnConfirmLogout] = useState(null);
//   useEffect(() => {
//     const fetchUser = async () => {
//       const userId = sessionStorage.getItem("userId");
//       const token = sessionStorage.getItem("token");
//       if (!userId || !token) {
//         setUser(null);
//         return;
//       }
//       try {
//         const userData = await fetchUserFromRedis(userId, token);
//         setUser(userData || null);
//       } catch (err) {
//         console.error("Error fetching user from Redis:", err);
//         setUser(null);
//       }
//     };
  
//     fetchUser();
//   }, [location]);
  

//   const EMERGENCY_API = process.env.REACT_APP_EMERGENCY_API;

//   const handleRaiseEmergency = async () => {
//     if (!user) {
//       setDialogMessage("User not found. Please log in again.");
//       setDialogOpen(true);
//       return;
//     }

//     try {
//       navigator.geolocation.getCurrentPosition(
//         async (pos) => {
//           const geo_location = {
//             lat: pos.coords.latitude,
//             lng: pos.coords.longitude,
//           };

//           const res = await axios.post(`${EMERGENCY_API}`, {
//             resident_id: user.user_id,
//             geo_location,
//           });

//           setDialogMessage(res.data.message);
//           setDialogOpen(true);
          
//         },
//         (err) => {
//           setDialogMessage("Unable to fetch location. Please enable GPS.");
//           setDialogOpen(true);
//           console.error(err);
//         }
//       );
//     } catch (err) {
//       console.error("Error raising emergency:", err);
//       setDialogMessage("Failed to raise emergency");
//       setDialogOpen(true);
//     }
//   };

//   const handleChange = (event, newValue) => {
//     if (newValue !== null) setSelected(newValue);
//   };
//   const confirmLogout = () => {
//     setDialogOpen(true); 
//   };
//   const handleLogout = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       const userId = sessionStorage.getItem("userId");
  
//       await fetch(`${logoutapi}/${userId}`, {
//         method: "POST",
//         headers: {
//           "Authorization": `Bearer ${token}`,
//         },
//       });
//       // Clear frontend session
//       sessionStorage.clear();
//       setUser(null);
//       handleMenuClose();
//       navigate("/Login");
//     } catch (error) {
//       console.error("Logout failed:", error);
//       sessionStorage.clear();
//       navigate("/Login");
//     }
//   };

//   const handleMenuOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const isActive = (path) => location.pathname === path;

//   return (
//     <AppBar position="static" sx={{ backgroundColor: "#fff", color: "#153f4b" }}>
//       <Toolbar sx={{ flexDirection: "column", padding: "0!important" }}>
//     {/* First Line: Main Navigation */}
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         width: "100%",
//         px: 15,
//         py: 1,
//       }}
//     >
//         {/* Left: Logo */}
//         <Box display="flex" alignItems="center">
//           <img
//             src={ayujalogo}
//             alt="Ayuja Logo"
//             width={150}
//             height={48}
//             style={{ marginRight: 10 }}
//           />
//         </Box>

//       {/* Center: Navigation Buttons */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: 4,
//           flexGrow: 1,
//         }}
//       >
//           <Button
//             onClick={() => navigate("/")}
//             sx={{
//               textTransform: "none",
//               color: isActive("/") ? "teal" : "#121212",
//               fontWeight: isActive("/") ? "bold" : "normal",
//               borderBottom: isActive("/") ? "2px solid teal" : "none",
//             }}
//           >
//             Home
//           </Button>

//         <Button
//   onClick={() =>
//     navigate(user?.role === "resident" ? "/services" : "/serviceweprovide")
//   }
//   sx={{
//     textTransform: "none",
//     color: isActive(user?.role === "resident" ? "/services" : "/serviceweprovide")
//         ? "teal"
//         : "#121212",
//       fontWeight: isActive(user?.role === "resident" ? "/services" : "/serviceweprovide")
//         ? "bold"
//         : "normal",
//       borderBottom: isActive(user?.role === "resident" ? "/services" : "/serviceweprovide")
//         ? "2px solid teal"
//         : "none",
//   }}
// >
//   Services
// </Button>

//           <Button
//             onClick={() => navigate("/aboutus")}
//             sx={{
//               textTransform: "none",
//               color: isActive("/aboutus") ? "teal" : "#121212",
//               fontWeight: isActive("/aboutus") ? "bold" : "normal",
//               borderBottom: isActive("/aboutus") ? "2px solid teal" : "none",
//             }}
//           >
//             About Us
//           </Button>

//           <Button
//             onClick={() => navigate("/packages")}
//             sx={{
//               textTransform: "none",
//               color: isActive("/packages") ? "teal" : "#121212",
//               fontWeight: isActive("/packages") ? "bold" : "normal",
//               borderBottom: isActive("/packages") ? "2px solid teal" : "none",
//             }}
//           >
//             Packages
//           </Button>

//           <Button
//             onClick={() => navigate("/contactus")}
//             sx={{
//               textTransform: "none",
//               color: isActive("/contactus") ? "teal" : "#121212",
//               fontWeight: isActive("/contactus") ? "bold" : "normal",
//               borderBottom: isActive("/contactus") ? "2px solid teal" : "none",
//             }}
//           >
//             Contact Us
//           </Button>
//         </Box>

//       {/* Right: Login/Register or SOS */}
//       <Box sx={{ display: "flex", alignItems: "center", gap: 10 }}>
//         {/* Resident-only SOS button */}
//         {/* {user?.role === "resident" && (
//           <IconButton
//             onClick={() => {
//               const confirmEmergency = window.confirm(
//                 "Are you sure you want to raise an emergency?"
//               );
//               if (confirmEmergency) {
//                 handleRaiseEmergency();
//               }
//             }}
//             sx={{
//               backgroundColor: "red",
//               color: "white",
//               fontWeight: "bold",
//               fontSize: "14px",
//               width: 40,
//               height: 40,
//               borderRadius: "50%",
//               "&:hover": { backgroundColor: "darkred" },
//             }}
//           >
//             SOS
//           </IconButton>
//         )} */}

//         {!user && (
//           <ToggleButtonGroup
//             value={selected}
//             exclusive
//             onChange={handleChange}
//             sx={{
//               width: "150px",
//               height: "35px",
//               borderRadius: "30px",
//               overflow: "hidden",
//               border: "1px solid teal",
//             }}
//           >
//             <ToggleButton
//               value="login"
//               onClick={() => navigate("/Login")}
//               sx={{
//                 textTransform: "none",
//                 fontWeight: "bold",
//                 px: 2,
//                 "&.Mui-selected": {
//                   background: "linear-gradient(to right, seagreen, #22577A)",
//                   color: "white",
//                 },
//               }}
//             >
//               Login
//             </ToggleButton>
//             <ToggleButton
//               value="register"
//               onClick={() => navigate("/Register")}
//               sx={{
//                 textTransform: "none",
//                 fontWeight: "bold",
//                 px: 1,
//                 "&.Mui-selected": {
//                   background: "linear-gradient(to right, seagreen, #22577A)",
//                   color: "white",
//                 },
//               }}
//             >
//               Register
//             </ToggleButton>
//           </ToggleButtonGroup>
//         )}
//       </Box>
//     </Box>

//     {/* Second Line: User Menu (only when user is logged in) */}
//     {user && (

//   <Box
//     sx={{
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       width: "100%",
//       backgroundColor: "white",
//       px: 20,
//       py: 1,
//       gap: 2, 
//       marginTop: 8,
//     }}
//   >
//     {/* User Info */}
//     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//       {/* Avatar */}
//       <Avatar
//         alt={user.name}
//         src={user.avatarUrl || ""} // If you have a profile image URL
//         sx={{ width: 40, height: 40, bgcolor: "#007a85", fontWeight: "bold" }}
//       >
//         {!user.avatarUrl && user.name ? user.name.charAt(0).toUpperCase() : ""}
//       </Avatar>

//       {/* User Name */}
//       <Typography
//         variant="body1"
//         sx={{ color: "black", fontWeight: "bold" }}
//       >
//         {user.name}
//       </Typography>
//     </Box>

//         {/* User Menu Items */}
//         <Box sx={{ display: "flex", alignItems: "center", gap: 8 }}>
//           <Button
//             onClick={() => navigate("/services")}
//             sx={{
//               textTransform: "none",
//               color: "black",
//               fontWeight: "normal",
//               fontSize: "16px",
//             }}
//           >
//             Home
//           </Button>

//           <Button
//             onClick={() => navigate("/profile-details")}
//             sx={{
//               textTransform: "none",
//               color: "black",
//               fontWeight: "normal",
//               fontSize: "16px",
//             }}
//           >
//             Profile
//           </Button>

//           {user?.role === "resident" && (
//             <>
//               <Button
//                 onClick={() => navigate("/my-orders")}
//                 sx={{
//                   textTransform: "none",
//                   color: "black",
//                   fontWeight: "normal",
//                   fontSize: "16px",
//                 }}
//               >
//                 My Medicine Orders
//               </Button>

//               <Button
//                 onClick={() => navigate("/my-bookings")}
//                 sx={{
//                   textTransform: "none",
//                   color: "black",
//                   fontWeight: "normal",
//                   fontSize: "16px",
//                 }}
//               >
//                 Sample Collection Orders
//               </Button>

//               <Button
//                 onClick={() => navigate("/cancelled-bookings")}
//                 sx={{
//                   textTransform: "none",
//                   color: "black",
//                   fontWeight: "normal",
//                   fontSize: "16px",
//                 }}
//               >
//                 Cancellations
//               </Button>

//               <Button
//                 onClick={() => navigate("/my-complaints")}
//                 sx={{
//                   textTransform: "none",
//                   color: "black",
//                   fontWeight: "normal",
//                   fontSize: "16px",
//                 }}
//               >
//                 My Complaints
//               </Button>
//             </>
//           )}


//       <Button
//         onClick={confirmLogout}
//         sx={{
//           textTransform: "none",
//           color: "black",
//           fontWeight: "normal",
//           fontSize: "16px",
//         }}
//       >
//         Logout
//       </Button>


//         </Box>
//       </Box>
//     )}
//   </Toolbar>
//   <CustomDialog
//     open={dialogOpen}
//     title="Confirm Logout"
//     message="Are you sure you want to log out?"
//     onClose={() => setDialogOpen(false)}
//     buttonText="Yes"
//     secondaryButtonText="Cancel"
//     onPrimaryAction={() => {
//       setDialogOpen(false);
//       handleLogout();
//     }}
//     onSecondaryAction={() => setDialogOpen(false)}
//     type="warning"
//   />


// </AppBar>
//   );
// }

// export default Header;



import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  styled,
  Avatar
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import ayujalogo from "../Logos/Ayuja_Logo.jpg";
import axios from "axios";
import { fetchUserFromRedis } from "../../Components/HomePage/AuthonticationScreens/Register";
import CustomDialog from "../../CustomDialog";

const StyledAvatar = styled("div")`
  font-family: "Roboto";
  letter-spacing: 0.1px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #006D77;
  color: white;
  font-size: 20px;
  font-weight: bold;
  border-radius: 50%;
`;

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selected, setSelected] = useState("");
  const [user, setUser] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const logoutapi = process.env.REACT_APP_LOGOUT_API;
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) {
        setUser(null);
        return;
      }
      try {
        const userData = await fetchUserFromRedis(userId, token);
        setUser(userData || null);
      } catch (err) {
        console.error("Error fetching user from Redis:", err);
        setUser(null);
      }
    };

    fetchUser();
  }, [location]);



  const handleChange = (event, newValue) => {
    if (newValue !== null) setSelected(newValue);
  };

  const confirmLogout = () => {
    setDialogOpen(true);
  };

  const handleLogout = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const userId = sessionStorage.getItem("userId");

      await fetch(`${logoutapi}/${userId}`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });
      // Clear frontend session
      sessionStorage.clear();
      setUser(null);
      handleMenuClose();
      navigate("/Login");
    } catch (error) {
      console.error("Logout failed:", error);
      sessionStorage.clear();
      navigate("/Login");
    }
  };


  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <AppBar position="static" sx={{ backgroundColor: "#fff", color: "#153f4b" }}>
      <Toolbar sx={{ flexDirection: "column", padding: "0!important" }}>
        {/* First Line: Only shown when user is NOT logged in */}
        {!user && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              px: 150,
              py: 1,
            }}
          >
            {/* Left: Logo */}
            <Box display="flex" alignItems="center">
              <img
                src={ayujalogo}
                alt="Ayuja Logo"
                width={150}
                height={48}
                style={{ marginRight: 10 }}
              />
            </Box>

            {/* Center: Navigation Buttons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 4,
                flexGrow: 1,
              }}
            >
              <Button
                onClick={() => navigate("/")}
                sx={{
                  textTransform: "none",
                  color: isActive("/") ? "teal" : "#121212",
                  fontWeight: isActive("/") ? "bold" : "normal",
                  borderBottom: isActive("/") ? "2px solid teal" : "none",
                }}
              >
                Home
              </Button>

              <Button
                onClick={() => navigate("/serviceweprovide")}
                sx={{
                  textTransform: "none",
                  color: isActive("/serviceweprovide") ? "teal" : "#121212",
                  fontWeight: isActive("/serviceweprovide") ? "bold" : "normal",
                  borderBottom: isActive("/serviceweprovide") ? "2px solid teal" : "none",
                }}
              >
                Services
              </Button>

              <Button
                onClick={() => navigate("/aboutus")}
                sx={{
                  textTransform: "none",
                  color: isActive("/aboutus") ? "teal" : "#121212",
                  fontWeight: isActive("/aboutus") ? "bold" : "normal",
                  borderBottom: isActive("/aboutus") ? "2px solid teal" : "none",
                }}
              >
                About Us
              </Button>

              <Button
                onClick={() => navigate("/packages")}
                sx={{
                  textTransform: "none",
                  color: isActive("/packages") ? "teal" : "#121212",
                  fontWeight: isActive("/packages") ? "bold" : "normal",
                  borderBottom: isActive("/packages") ? "2px solid teal" : "none",
                }}
              >
                Packages
              </Button>

              <Button
                onClick={() => navigate("/contactus")}
                sx={{
                  textTransform: "none",
                  color: isActive("/contactus") ? "teal" : "#121212",
                  fontWeight: isActive("/contactus") ? "bold" : "normal",
                  borderBottom: isActive("/contactus") ? "2px solid teal" : "none",
                }}
              >
                Contact Us
              </Button>
            </Box>

            {/* Right: Login/Register */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 10 }}>
              <ToggleButtonGroup
                value={selected}
                exclusive
                onChange={handleChange}
                sx={{
                  width: "150px",
                  height: "35px",
                  borderRadius: "30px",
                  overflow: "hidden",
                  border: "1px solid teal",
                }}
              >
                <ToggleButton
                  value="login"
                  onClick={() => navigate("/Login")}
                  sx={{
                    textTransform: "none",
                    fontWeight: "bold",
                    px: 2,
                    "&.Mui-selected": {
                      background: "linear-gradient(to right, seagreen, #22577A)",
                      color: "white",
                    },
                  }}
                >
                  Login
                </ToggleButton>
                <ToggleButton
                  value="register"
                  onClick={() => navigate("/Register")}
                  sx={{
                    textTransform: "none",
                    fontWeight: "bold",
                    px: 1,
                    "&.Mui-selected": {
                      background: "linear-gradient(to right, seagreen, #22577A)",
                      color: "white",
                    },
                  }}
                >
                  Register
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </Box>
        )}

        {/* Second Line: User Menu (only when user is logged in) */}
        {user && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              backgroundColor: "white",
              px: 20,
              py: 1,
              gap: 2,
            }}
          >
            {/* Logo on the left when logged in */}
            <Box display="flex" alignItems="center">
              <img
                src={ayujalogo}
                alt="Ayuja Logo"
                width={150}
                height={48}
              />
            </Box>

            {/* User Menu Items in Center */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 8, flexGrow: 1, justifyContent: "center" }}>
              <Button
                onClick={() => navigate("/services")}
                sx={{
                  textTransform: "none",
                  color: "black",
                  fontWeight: "normal",
                  fontSize: "16px",
                }}
              >
                Home
              </Button>

              <Button
                onClick={() => navigate("/profile-details")}
                sx={{
                  textTransform: "none",
                  color: "black",
                  fontWeight: "normal",
                  fontSize: "16px",
                }}
              >
                Profile
              </Button>

              {user?.role === "resident" && (
                <>

                  <Button
                    onClick={() => navigate("/my-orders")}
                    sx={{
                      textTransform: "none",
                      color: "black",
                      fontWeight: "normal",
                      fontSize: "16px",
                    }}
                  >
                    My Medicine Orders
                  </Button>

                  <Button
                    onClick={() => navigate("/my-bookings")}
                    sx={{
                      textTransform: "none",
                      color: "black",
                      fontWeight: "normal",
                      fontSize: "16px",
                    }}
                  >
                    Sample Collection Orders
                  </Button>

                  <Button
                    onClick={() => navigate("/cancelled-bookings")}
                    sx={{
                      textTransform: "none",
                      color: "black",
                      fontWeight: "normal",
                      fontSize: "16px",
                    }}
                  >
                    Cancellations
                  </Button>

                  <Button
                    onClick={() => navigate("/my-complaints")}
                    sx={{
                      textTransform: "none",
                      color: "black",
                      fontWeight: "normal",
                      fontSize: "16px",
                    }}
                  >
                    My Complaints
                  </Button>



                  <Button
                    onClick={() => navigate("/subscription-management")}
                    sx={{
                      textTransform: "none",
                      color: "black",
                      fontWeight: "normal",
                      fontSize: "16px",
                    }}
                  >
                  Subscription Plans
                  </Button>

                </>
              )}

              <Button
                onClick={confirmLogout}
                sx={{
                  textTransform: "none",
                  color: "black",
                  fontWeight: "normal",
                  fontSize: "16px",
                }}
              >
                Logout
              </Button>
            </Box>

            {/* User Info on the right */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar
                alt={user.name}
                src={user.avatarUrl || ""}
                sx={{ width: 40, height: 40, bgcolor: "#007a85", fontWeight: "bold" }}
              >
                {!user.avatarUrl && user.name ? user.name.charAt(0).toUpperCase() : ""}
              </Avatar>

              <Typography
                variant="body1"
                sx={{ color: "black", fontWeight: "bold" }}
              >
                {user.name}
              </Typography>
            </Box>
          </Box>
        )}
      </Toolbar>

      <CustomDialog
        open={dialogOpen}
        title="Confirm Logout"
        message="Are you sure you want to log out?"
        onClose={() => setDialogOpen(false)}
        buttonText="Yes"
        secondaryButtonText="Cancel"
        onPrimaryAction={() => {
          setDialogOpen(false);
          handleLogout();
        }}
        onSecondaryAction={() => setDialogOpen(false)}
        type="warning"
      />
    </AppBar>
  );
}

export default Header;